import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import {Alert, Stack, Tabs} from "@mui/material";
import Container from "@mui/material/Container";
import Tab from "@mui/material/Tab";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {isEventManager} from "../../hooks/useUserRole";
import EventHeading from "../../components/Event/EventHeading";
import {useGetDaysQuery, useLazyGetEventDefinitionQuery} from "../../slices/apiSlice";
import {setDays, setEventRules} from "../../slices/sessionSlice";

const tabGroups = {
    pilot: [
        {
            label:'Briefing',
            path:'./briefing',
        },
        {
            label:'Event info',
            path:'./info',
        },
        {
            label:'Registration',
            path:'./registration',
        },
    ],
    manager: [
        {
            label:'Briefing',
            path:'./briefing',
        },
        {
            label:'Event info',
            path:'./info',
        },
        {
            label:'Settings',
            path:'./settings',
        },
    ]
}


const getTabIndex = (url,tabs) => {
    const ending = url.split('/').pop()
    const ret =  tabs.findIndex( tab => tab.path.endsWith(ending))

    return ret !== -1 ? ret : 1
}

const EventHome = () => {
    const event = useSelector(state => state.session.event)
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const session = useSelector(state=> state.session)

    const [tabs, setTabs] = React.useState(tabGroups[isEventManager(session,session.event?.id) ? 'manager' : 'pilot'])
    const [tabValue, setTabValue] = React.useState(getTabIndex(location.pathname,tabs))

    const {data: days, isSuccess: isDaysSuccess} =
    useGetDaysQuery(event?.id,{skip:!event})

    const [getEventDefinition, getEventDefinitionResult] =
        useLazyGetEventDefinitionQuery()


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
        navigate(tabs[newValue].path)
    }

    useEffect(() => {
        const tabs = tabGroups[isEventManager(session,session.event?.id) ? 'manager' : 'pilot']
        setTabs(tabs)
        setTabValue(getTabIndex(location.pathname,tabs))
        if (event && !session.eventRules) {
            getEventDefinition(event.id)
        }
    }, [session.services,session.event]);

    useEffect(() => {
        dispatch(setDays(days))
    }, [isDaysSuccess]);

    useEffect(() => {
        if (getEventDefinitionResult.isSuccess) {
            dispatch(setEventRules(getEventDefinitionResult.data.rules))
        }
    }, [getEventDefinitionResult]);

    return (
        <>
            <EventHeading/>
            <Container maxWidth={'xl'}>
                <Box mb={2}>
                    <Tabs value={tabValue} onChange={handleTabChange}>
                        {tabs.map((tab,idx) => <Tab id={`tab-${idx}`} key={`tab-${idx}`} label={tab.label} />)}
                    </Tabs>
                </Box>
                <Outlet/>
            </Container>
        </>
    );
};

export default EventHome;